var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C10.7812 0 9.375 1.40625 9.375 3.125V46.875C9.375 48.5938 10.7812 50 12.5 50H43.75C45.4688 50 46.875 48.5938 46.875 46.875V12.5L34.375 0H12.5Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 12.5H46.875L34.375 0V9.375C34.375 11.0938 35.7812 12.5 37.5 12.5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 21.875L37.5 12.5H46.875V21.875Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 40.625C40.625 41.4844 39.9219 42.1875 39.0625 42.1875H4.6875C3.82812 42.1875 3.125 41.4844 3.125 40.625V25C3.125 24.1406 3.82812 23.4375 4.6875 23.4375H39.0625C39.9219 23.4375 40.625 24.1406 40.625 25V40.625Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93555 29.6047C9.93555 29.1922 10.2605 28.7422 10.784 28.7422H13.6699C15.2949 28.7422 16.7574 29.8297 16.7574 31.9141C16.7574 33.8891 15.2949 34.9891 13.6699 34.9891H11.584V36.6391C11.584 37.1891 11.234 37.5 10.784 37.5C10.3715 37.5 9.93555 37.1891 9.93555 36.6391V29.6047ZM11.584 30.3156V33.4281H13.6699C14.5074 33.4281 15.1699 32.6891 15.1699 31.9141C15.1699 31.0406 14.5074 30.3156 13.6699 30.3156H11.584Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2043 37.4998C18.7918 37.4998 18.3418 37.2748 18.3418 36.7264V29.6295C18.3418 29.1811 18.7918 28.8545 19.2043 28.8545H22.0652C27.7746 28.8545 27.6496 37.4998 22.1777 37.4998H19.2043ZM19.9918 30.3795V35.9764H22.0652C25.4387 35.9764 25.5887 30.3795 22.0652 30.3795H19.9918Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6744 30.4796V32.4655H32.8604C33.3104 32.4655 33.7604 32.9155 33.7604 33.3515C33.7604 33.764 33.3104 34.1015 32.8604 34.1015H29.6744V36.7249C29.6744 37.1624 29.3635 37.4983 28.926 37.4983C28.376 37.4983 28.04 37.1624 28.04 36.7249V29.628C28.04 29.1796 28.3775 28.853 28.926 28.853H33.3119C33.8619 28.853 34.1869 29.1796 34.1869 29.628C34.1869 30.028 33.8619 30.478 33.3119 30.478H29.6744V30.4796Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0625 42.1875H9.375V43.75H39.0625C39.9219 43.75 40.625 43.0469 40.625 42.1875V40.625C40.625 41.4844 39.9219 42.1875 39.0625 42.1875Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.459add76742d333418a45c852bd1a156.svg";
export { ForwardRef as ReactComponent };